import { useFeatureFlagsContext } from "./FeatureFlag.context";
import { FeatureFlagNames } from "./featureFlags.types";

export const useFeatureFlag = (featureFlagKey: FeatureFlagNames) => {
  const { featureFlagsConfig } = useFeatureFlagsContext();
  return featureFlagsConfig[featureFlagKey] || false;
};
